import React, { Component } from "react";
import html2canvas from "html2canvas";
import KishuAtttributes from "./kishu/attributes.json";
import KishuTalents from "./kishu/talents.json";

class Breeder extends Component {
  constructor(props) {
    super(props);

    const birthDate = new Date();
    const gender = this.getGender();
    const traits = this.getTalents(this.props.dad, this.props.mom);
    const stats = this.getStats(traits);

    const attributes = this.getAttributes(
      this.props.dad,
      this.props.mom,
      gender
    );

    this.state = {
      dad: this.props.dad,
      mom: this.props.mom,
      gender: gender,
      traits: traits,
      stats: stats,
      attributes: attributes,
      birthDate: birthDate.toDateString(),
      img: "",
      errMsg: [],
    };

    this.printRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    let updateM = false;
    let updateP = false;
    if (prevProps.mom !== this.props.mom) {
      this.setState({ mom: this.props.mom });
      updateM = true;
    }
    if (prevProps.dad !== this.props.dad) {
      this.setState({ dad: this.props.dad });
      updateP = true;
    }

    if (updateM) {
      if (updateP) {
        //console.log(this.state.json);
        const gender = this.getGender();
        const attributes = this.getAttributes(
          this.props.dad,
          this.props.mom,
          gender
        );
        //console.log("Attributes", attributes);
        const traits = this.getTalents(this.props.dad, this.props.mom);
        const stats = this.getStats(traits);
        this.setState({
          gender: gender,
          attributes: attributes,
          traits: traits,
          stats: stats,
          errMsg: [],
        });

        this.props.updateBabyKishu(
          this.buildBabyKishu(gender, stats, traits, attributes, this.state.img)
        );
      }
    }
  }

  render() {
    if (this.state.dad === "" || this.state.mom === "")
      return (
        <div className="row" style={{ position: "relative" }}>
          <div className="col-sm-4">Invalid Kishu combination</div>
        </div>
      );
    else {
      const imgWidth = "200px";
      const imgHeight = "215px";
      const handleDownloadImage = async () => {
        const element = this.printRef.current;
        const canvas = await html2canvas(element, {
          useCORS: true,
          allowTaint: true,
          logging: true,
          backgroundColor: null,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight,
          scale: 5,
        });
        //console.log("Canvas is: ", element);

        const data = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        this.setState({ img: data });
        //console.log("1 Data: ", data);

        if (typeof link.download === "string") {
          //console.log("Link: ", link);
          link.href = data;
          link.download = "image.png";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          //console.log("Data: ", data);
          window.open(data);
        }
      };

      const renderStats = () => {
        return (
          <p className="">
            Power: {this.state.stats[0]}
            <br />
            Speed: {this.state.stats[1]}
            <br />
            Weight: {this.state.stats[2]}
            <br />
            Smarts: {this.state.stats[3]}
          </p>
        );
      };

      const renderTraits = this.state.traits.map((txt, i) => {
        return (
          <p key={i} className="">
            {txt[0]} ({txt[1]})
            <br />
            Rank: {txt[2]} Dom: {txt[3]} <br />
            P: {txt[4]} Sp: {txt[5]}
            <br />
            W: {txt[6]} Sm: {txt[7]}
          </p>
        );
      });

      const renderAttributes = this.state.attributes.map((attribute, i) => {
        //console.log("Attr: ", this.state.attributes);
        /***
         * TODO: Image data only updates when the "save as" button is clicked.
         * Need to find out how to export data to an object and then write that object
         * to file, screen, chain, etc
         */
        if (
          attribute[0].toLowerCase() !== "background" &&
          attribute[1].toLowerCase() !== "none"
        ) {
          return (
            <img
              alt="Baby Kishu"
              src={`./images/traits/${attribute[2]}/${
                attribute[0]
              }/${attribute[1].replaceAll(" ", "-")}.png`}
              onError={({ currentTarget }) => {
                currentTarget.src = "./images/img-error.png";
                const tempAttr = this.state.attributes.slice(); //copy the array
                tempAttr[i][3] = true; //execute the manipulations
                const pID =
                  attribute[2] === "m"
                    ? this.state.dad["edition"]
                    : this.state.mom["edition"];
                this.setState({
                  attributes: tempAttr,
                  errMsg: [
                    ...this.state.errMsg,
                    `${attribute[1]} ${attribute[0]} (${pID} ${attribute[2]})`,
                  ],
                }); //set the new state
              }}
              key={i}
              style={{
                position: "absolute",
                zIndex: 1 * i,
                top: "0px",
                left: "0px",
                width: imgWidth,
                height: imgHeight,
              }}
            ></img>
          );
        } else {
          return "";
        }
      });

      return (
        <div className="row" style={{ position: "relative" }}>
          <div className="col-sm-4">
            <div className="">
              <h3>Attributes</h3>
            </div>
            <div className="">
              Baby Kishu ({this.state.gender === "m" ? "male" : "female"})
            </div>
            <div className="">Born: {this.state.birthDate}</div>
            <div className="">
              {this.state.attributes.map((attr, i) => (
                <p key={i} className={attr[3] ? "text-danger" : ""}>
                  {attr[2]} {attr[0]} {attr[1].replaceAll("-", " ")}
                </p>
              ))}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="">
              <h3>
                TRAITS
                <br />
              </h3>
              {renderTraits}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="">
              <h3>
                STATS
                <br />
              </h3>
              {renderStats()}
            </div>
          </div>
          <div className="row" style={{ position: "relative" }}>
            <div
              className="col-sm-12"
              style={{
                position: "relative",
                width: imgWidth,
                height: imgHeight,
              }}
              ref={this.printRef}
            >
              {renderAttributes}
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="btn-warning rounded mx-4"
                onClick={() => {
                  const gender = this.getGender();
                  const traits = this.getTalents(
                    this.props.dad,
                    this.props.mom
                  );
                  const stats = this.getStats(traits);
                  const attributes = this.getAttributes(
                    this.props.dad,
                    this.props.mom,
                    gender
                  );
                  this.setState({
                    gender: gender,
                    attributes: attributes,
                    traits: traits,
                    stats: stats,
                    errMsg: [],
                  });

                  this.props.updateBabyKishu(
                    this.buildBabyKishu(
                      gender,
                      stats,
                      traits,
                      attributes,
                      this.state.img
                    )
                  );
                }}
              >
                Bonga Bonga
              </button>

              <button
                className="btn-primary rounded mx-4"
                onClick={handleDownloadImage}
              >
                Export As PNG
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-center py-3">
            <div className="input-group input-group-sm">
              <span className="input-group-text" id="inputGroup-sizing-sm">
                Err
              </span>
              <input
                type="text"
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                disabled
                value={
                  this.state.errMsg.length > 0
                    ? "Missing Attr: " +
                      this.state.errMsg.map((msg) => msg).join(", ")
                    : ""
                }
              />
            </div>
          </div>
        </div>
      );
    }
  }

  buildBabyKishu(gender, stats, traits, attributes, img) {
    console.log("image: ", img);
    const babyKishuJson = {
      dna: "xxx",
      name: "#1",
      description:
        (gender === "m" ? "Male" : "Female") + " Kishus: Generation Two",
      image: img, //"ipfs://QmV13Fg8vK8UP4HMMM59F2ByzNgkd6bdFCKFMRJjwzPpry/1.png",
      edition: 1,
      date: 1635168920795,
      stats: [
        {
          name: "Power",
          value: stats[0],
        },
        {
          name: "Speed",
          value: stats[1],
        },
        {
          name: "Weight",
          value: stats[2],
        },
        {
          name: "Smart",
          value: stats[3],
        },
      ],
      traits: [
        {
          name: traits[0][0],
          category: traits[0][1],
          rank: traits[0][2],
          dominance: traits[0][3],
          power: traits[0][4],
          speed: traits[0][5],
          weight: traits[0][6],
          smarts: traits[0][7],
        },
        {
          name: traits[1][0],
          category: traits[1][1],
          rank: traits[1][2],
          dominance: traits[1][3],
          power: traits[1][4],
          speed: traits[1][5],
          weight: traits[1][6],
          smarts: traits[1][7],
        },
        {
          name: traits[2][0],
          category: traits[2][1],
          rank: traits[2][2],
          dominance: traits[2][3],
          power: traits[2][4],
          speed: traits[2][5],
          weight: traits[2][6],
          smarts: traits[2][7],
        },
      ],
      attributes: [
        {
          trait_type: "background",
          value: "",
        },
        {
          trait_type: "skins",
          value: attributes[1][1],
        },
        {
          trait_type: "face",
          value: attributes[2][1],
        },
        {
          trait_type: "eyes",
          value: attributes[3][1],
        },
        {
          trait_type: "mouths",
          value: attributes[4][1],
        },
        {
          trait_type: "clothes",
          value: attributes[5][1],
        },
        {
          trait_type: "hats",
          value: attributes[6][1],
        },
      ],
      compiler: "HashLips Art Engine",
    };
    return babyKishuJson;
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

  getGender() {
    const value = this.getRandomIntInclusive(1, 10);
    if (value < 6) return "m";
    else return "f";
  }

  getStats(traits) {
    var pw = 0,
      sp = 0,
      wt = 0,
      sm = 0;
    traits.forEach((txt, i) => {
      pw += parseInt(txt[4]);
      sp += parseInt(txt[5]);
      wt += parseInt(txt[6]);
      sm += parseInt(txt[7]);
    });
    //console.log("Stats: ", [pw, sp, wt, sm]);
    return [pw, sp, wt, sm];
  }

  getTalents(dad, mom) {
    //dad = require(`./kishu/male-json/${dad}.json`);
    //mom = require(`./kishu/female-json/${mom}.json`);

    var traits = [],
      dadTRV = 0, //Dad trait roll value
      momTRV = 0, //Mom trait roll value
      pv = 0, //pooled value
      dadTTC = 0, //dad true trait chance
      momTTC = 0, //mmom true trait chance
      gmc = 0, //genetic mutation cance
      trr = 0, //trait rank range
      name = "", //selected trait name
      category = "", //selected trait category
      rank = "", //selected trait rank
      dominance = 0, //selected trait dominance
      power = 0,
      speed = 0,
      weight = 0,
      smarts = 0,
      randInt = 0;

    var maxPos = 0;
    try {
      maxPos = dad["traits"].length;
    } catch (error) {
      maxPos = 3;
    }

    //Cycle through traits and process
    for (var pos = 0; pos < maxPos; pos++) {
      try {
        dadTRV = (dad["traits"][pos]["dominance"] / 100) * 25 + 50;
      } catch (error) {
        dadTRV = 0;
      }
      try {
        momTRV = (mom["traits"][pos]["dominance"] / 100) * 25 + 50;
      } catch (error) {
        momTRV = 0;
      }

      pv = dadTRV + momTRV;
      dadTTC =
        parseInt(dadTRV / pv) * 100 +
        parseInt(this.getRandomIntInclusive(1, 100));
      try {
        rank = parseInt(dad["traits"][pos]["rank"]);
      } catch (error) {
        rank = 0;
      }
      dadTTC += rank;
      momTTC =
        parseInt(momTRV / pv) * 100 +
        parseInt(this.getRandomIntInclusive(1, 100));
      try {
        rank = parseInt(mom["traits"][pos]["rank"]);
      } catch (error) {
        rank = 0;
      }
      momTTC += rank;

      gmc = ((((pv - 100) / -200) * 5) / 40) * 100;

      // console.log("D TRV TTC", dadTRV, dadTTC);
      // console.log("M TRV TTC", momTRV, momTTC);

      if (pv === 0 || this.getRandomIntInclusive(0, 99) < gmc) {
        //mutation, max 3.125, min 6.2
        const assets = KishuTalents;
        const index = this.getRandomIntInclusive(0, 82);
        name = KishuTalents[index][0];
        category = KishuTalents[index][1];
        rank = this.getRandomIntInclusive(1, 2);
        dominance = this.getRandomIntInclusive(1, 10);
        power = KishuTalents[index][2];
        speed = KishuTalents[index][3];
        weight = KishuTalents[index][4];
        smarts = KishuTalents[index][5];

        //pull name, power, speed, weight and smarts from lookup
      } else {
        if (dadTTC > momTTC) {
          //console.log("dad");
          //select father's trait
          trr = (dadTTC / 100) * 10;
          name = dad["traits"][pos]["name"];
          category = dad["traits"][pos]["category"];
          rank = dad["traits"][pos]["rank"];
          dominance = dad["traits"][pos]["dominance"];
          power = dad["traits"][pos]["power"];
          speed = dad["traits"][pos]["speed"];
          weight = dad["traits"][pos]["weight"];
          smarts = dad["traits"][pos]["smarts"];
        } else {
          //console.log("mom");
          //select mother's trait
          trr = (momTTC / 100) * 10;
          name = mom["traits"][pos]["name"];
          category = mom["traits"][pos]["category"];
          rank = mom["traits"][pos]["rank"];
          dominance = mom["traits"][pos]["dominance"];
          power = mom["traits"][pos]["power"];
          speed = mom["traits"][pos]["speed"];
          weight = mom["traits"][pos]["weight"];
          smarts = mom["traits"][pos]["smarts"];
        }
        //TRR
        randInt = this.getRandomIntInclusive(-1, 2);
        rank = parseFloat(rank) + parseFloat(randInt);
        if (rank < 1) rank = 1;
        else if (rank > 10) rank = 10;
        //how much does each trait go up per rank level?

        randInt = this.getRandomIntInclusive(0, 2) * 0.5;
        dominance = parseInt(parseFloat(dominance) + trr * randInt);
        if (dominance < 1) dominance = 1;
        else if (dominance > 100) dominance = 100;
      }

      traits.push([
        name,
        category,
        rank,
        dominance,
        power,
        speed,
        weight,
        smarts,
      ]);
    } //for
    //console.log(traits);
    return traits;
  }

  getAttributes(dad, mom, gender) {
    if (dad === "" || mom === "") return [];
    else {
      let attributes = [];

      attributes = dad["attributes"].map((dadAttr, i) => {
        const momAttr = mom["attributes"][i];
        const randNum = this.getRandomIntInclusive(1, 100);

        const traitType = dadAttr["trait_type"].toLowerCase();
        if (traitType === "clothes" && gender === "m") {
          return [traitType, "blue diaper", "m", false];
        } else if (traitType === "clothes" && gender === "f") {
          return [traitType, "pink diaper", "f", false];
        }

        if (randNum > 95) {
          //MUTATION: look up all artwork assets and set a new one
          const assets = KishuAtttributes[gender][traitType];
          const newAssetID = this.getRandomIntInclusive(0, assets.length - 1);
          let newAttribute = assets[newAssetID];
          try {
            newAttribute = newAttribute.substring(0, newAttribute.length - 4);
          } catch (error) {
            this.setState({ errMsg: error });
          }

          return [traitType, newAttribute, gender, false];
        } else if (randNum > 47) {
          return [
            momAttr["trait_type"],
            momAttr["value"],
            momAttr["trait_type"] === "clothes" ? gender : "f",
            false,
          ];
        } else
          return [
            dadAttr["trait_type"],
            dadAttr["value"],
            dadAttr["trait_type"] === "clothes" ? gender : "m",
            false,
          ];
      });
      //console.log(attributes);
      return attributes;
    }
  }
}

export default Breeder;

/******* ALTERNATIVE WAY OF BUILDING A STACKED IMAGE USING DIVS           
  <div
    key={i}
    style={{
      position: "absolute",
      zIndex: 1 * i,
      top: "0px",
      width: "200px",
      height: "215px",
      border: "solid thin black",
      backgroundImage: `url("./images/traits/${attribute[2]}/${
        attribute[0]
      }/${attribute[1].replace(" ", "-")}.png")`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
    }}
  ></div>
 */
